export var getEncodedUrl = function getEncodedUrl(path, data) {
  var params = Object.keys(data).map(function (key) {
    return key && data[key] ? "".concat(key, "=").concat(encodeURIComponent(data[key])) : "";
  }).filter(Boolean).join("&");
  return "".concat(path, "?").concat(params);
};
export function encodeSearchTerm() {
  var term = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var termArray = term.split(" ");

  if (termArray.length == 1) {
    return encodeURI(term);
  } else {
    return termArray.map(function (term) {
      return encodeURIComponent(term);
    }).join("+");
  }
}